import api, {handleAPIErrors} from 'shared/api'

const FETCH_ADJUST_REQUEST = 'futureRemCalculations/FETCH_ADJUST_REQUEST'
const FETCH_ADJUST_SUCCESS = 'futureRemCalculations/FETCH_ADJUST_SUCCESS'
const FETCH_ADJUST_FAILURE = 'futureRemCalculations/FETCH_ADJUST_FAILURE'
const CALCULATE_ADJUST_REQUEST = 'futureRemCalculations/CALCULATE_ADJUST_REQUEST'
const CALCULATE_ADJUST_SUCCESS = 'futureRemCalculations/CALCULATE_ADJUST_SUCCESS'
const CALCULATE_ADJUST_FAILURE = 'futureRemCalculations/CALCULATE_ADJUST_FAILURE'
const RESET_ADJUST_REQUEST = 'futureRemCalculations/RESET_ADJUST_REQUEST'
const RESET_ADJUST_SUCCESS = 'futureRemCalculations/RESET_ADJUST_SUCCESS'
const RESET_ADJUST_FAILURE = 'futureRemCalculations/RESET_ADJUST_FAILURE'
const FETCH_ESTIMATE_REQUEST = 'futureRemCalculations/FETCH_ESTIMATE_REQUEST'
const FETCH_ESTIMATE_SUCCESS = 'futureRemCalculations/FETCH_ESTIMATE_SUCCESS'
const FETCH_ESTIMATE_FAILURE = 'futureRemCalculations/FETCH_ESTIMATE_FAILURE'
const CALCULATE_ESTIMATE_REQUEST = 'futureRemCalculations/CALCULATE_ESTIMATE_REQUEST'
const CALCULATE_ESTIMATE_SUCCESS = 'futureRemCalculations/CALCULATE_ESTIMATE_SUCCESS'
const CALCULATE_ESTIMATE_FAILURE = 'futureRemCalculations/CALCULATE_ESTIMATE_FAILURE'
const RESET_ESTIMATE_REQUEST = 'futureRemCalculations/RESET_ESTIMATE_REQUEST'
const RESET_ESTIMATE_SUCCESS = 'futureRemCalculations/RESET_ESTIMATE_SUCCESS'
const RESET_ESTIMATE_FAILURE = 'futureRemCalculations/RESET_ESTIMATE_FAILURE'

const initialState = {
  adjust_filter: {},
  estimate_filter: {},
  estimate_salary: {},
  adjust_salary: {current: {}, adjusted: {}, difference: {}},
  adjustLoaded: false,
  adjustLoading: false,
  estimateLoaded: false,
  estimateLoading: false,
  calculatingEstimate: false,
  calculatedEstimate: false,
  calculatingAdjust: false,
  calculatedAdjust: false,
  resettingAdjust: false,
  resetAdjust: false,
  resettingEstimate: false,
  resetEstimate: false,
  errors: []
}

export function fetchAdjustRequest(payload = {}) {
  return {
    type: FETCH_ADJUST_REQUEST,
  }
}

export function fetchAdjustSuccess(payload) {
  return {
    type: FETCH_ADJUST_SUCCESS,
    payload,
  }
}

export function fetchAdjustFailure(errors = []) {
  return {
    type: FETCH_ADJUST_FAILURE,
    errors,
  }
}

export function calculateAdjustRequest(payload = {}) {
  return {
    type: CALCULATE_ADJUST_REQUEST,
  }
}

export function calculateAdjustSuccess(payload) {
  return {
    type: CALCULATE_ADJUST_SUCCESS,
    payload,
  }
}

export function calculateAdjustFailure(errors = []) {
  return {
    type: CALCULATE_ADJUST_FAILURE,
    errors,
  }
}

export function resetAdjustRequest(payload = {}) {
  return {
    type: RESET_ADJUST_REQUEST,
  }
}

export function resetAdjustSuccess(payload) {
  return {
    type: RESET_ADJUST_SUCCESS,
    payload,
  }
}

export function resetAdjustFailure(errors = []) {
  return {
    type: RESET_ADJUST_FAILURE,
    errors,
  }
}

export function fetchEstimateRequest(payload = {}) {
  return {
    type: FETCH_ESTIMATE_REQUEST,
  }
}

export function fetchEstimateSuccess(payload) {
  return {
    type: FETCH_ESTIMATE_SUCCESS,
    payload,
  }
}

export function fetchEstimateFailure(errors = []) {
  return {
    type: FETCH_ESTIMATE_FAILURE,
    errors,
  }
}

export function calculateEstimateRequest(payload = {}) {
  return {
    type: CALCULATE_ESTIMATE_REQUEST,
  }
}

export function calculateEstimateSuccess(payload) {
  return {
    type: CALCULATE_ESTIMATE_SUCCESS,
    payload,
  }
}

export function calculateEstimateFailure(errors = []) {
  return {
    type: CALCULATE_ESTIMATE_FAILURE,
    errors,
  }
}

export function resetEstimateRequest(payload = {}) {
  return {
    type: RESET_ESTIMATE_REQUEST,
  }
}

export function resetEstimateSuccess(payload) {
  return {
    type: RESET_ESTIMATE_SUCCESS,
    payload,
  }
}

export function resetEstimateFailure(errors = []) {
  return {
    type: RESET_ESTIMATE_FAILURE,
    errors,
  }
}

export function loadAdjustFilter(options = null, cb = null) {
  return (dispatch) => {
    dispatch(fetchAdjustRequest())

    return api(`api/v1/future_remunerations/adjust_filter`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchAdjustSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchAdjustFailure(errors))
        })
      })
  }
}

export function calculateAdjust(id, options = {}, cb = null) {
  const config = {
    method: 'PUT',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(calculateAdjustRequest())

    return api(`api/v1/future_remunerations/${id}/adjust`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(calculateAdjustSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(calculateAdjustFailure(errors))
        })
      })
  }
}

export function resetAdjust(cb) {
  return (dispatch) => {
    dispatch(resetAdjustRequest())

    return api(`api/v1/future_remunerations/reset_filter`, {type: 'adjust'})
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(resetAdjustSuccess(json))
        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(resetAdjustFailure(errors))
        })
      })
  }
}

export function loadEstimateFilter(options = null, cb = null) {
  return (dispatch) => {
    dispatch(fetchEstimateRequest())

    return api(`api/v1/future_remunerations/estimate_filter`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchEstimateSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchEstimateFailure(errors))
        })
      })
  }
}

export function calculateEstimate(id, options = {}, cb = null) {
  const config = {
    method: 'PUT',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(calculateEstimateRequest())

    return api(`api/v1/future_remunerations/${id}/estimate`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(calculateEstimateSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(calculateEstimateFailure(errors))
        })
      })
  }
}

export function resetEstimate(cb) {
  return (dispatch) => {
    dispatch(resetEstimateRequest())

    return api(`api/v1/future_remunerations/reset_filter`, {type: 'estimate'})
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(resetEstimateSuccess(json))
        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(resetEstimateFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_ADJUST_REQUEST:
      return Object.assign({}, state, {
        adjustLoading: true
      })
    case FETCH_ADJUST_SUCCESS:
      return Object.assign({}, state, {
        adjustLoading: false,
        adjustLoaded: true,
        errors: [],
        adjust_filter: payload
      })
    case FETCH_ADJUST_FAILURE:
      return Object.assign({}, state, {
        adjustLoaded: false,
        adjustLoading: false,
        errors: errors
      })
    case CALCULATE_ADJUST_REQUEST:
      return Object.assign({}, state, {
        calculatingAdjust: true
      })
    case CALCULATE_ADJUST_SUCCESS:
      return Object.assign({}, state, {
        calculatingAdjust: false,
        calculatedAdjust: true,
        errors: [],
        adjust_filter: payload.filter,
        adjust_salary: payload.calculation
      })
    case CALCULATE_ADJUST_FAILURE:
      return Object.assign({}, state, {
        calculatedAdjust: false,
        calculatingAdjust: false,
        errors: errors
      })
    case RESET_ADJUST_REQUEST:
      return Object.assign({}, state, {
        resettingAdjust: true
      })
    case RESET_ADJUST_SUCCESS:
      return Object.assign({}, state, {
        resettingAdjust: false,
        resetAdjust: true,
        errors: [],
        adjust_filter: payload
      })
    case RESET_ADJUST_FAILURE:
      return Object.assign({}, state, {
        resetAdjust: false,
        resettingAdjust: false,
        errors: errors
      })
    case FETCH_ESTIMATE_REQUEST:
      return Object.assign({}, state, {
        estimateLoading: true
      })
    case FETCH_ESTIMATE_SUCCESS:
      return Object.assign({}, state, {
        estimateLoading: false,
        estimateLoaded: true,
        errors: [],
        estimate_filter: payload
      })
    case FETCH_ESTIMATE_FAILURE:
      return Object.assign({}, state, {
        estimateLoaded: false,
        estimateLoading: false,
        errors: errors
      })
    case CALCULATE_ESTIMATE_REQUEST:
      return Object.assign({}, state, {
        calculatingEstimate: true
      })
    case CALCULATE_ESTIMATE_SUCCESS:
      return Object.assign({}, state, {
        calculatingEstimate: false,
        calculatedEstimate: true,
        errors: [],
        estimate_filter: payload.filter,
        estimate_salary: payload.calculation
      })
    case CALCULATE_ESTIMATE_FAILURE:
      return Object.assign({}, state, {
        calculatedEstimate: false,
        calculatingEstimate: false,
        errors: errors
      })
    case RESET_ESTIMATE_REQUEST:
      return Object.assign({}, state, {
        resettingEstimate: true
      })
    case RESET_ESTIMATE_SUCCESS:
      return Object.assign({}, state, {
        resettingEstimate: false,
        resetEstimate: true,
        errors: [],
        estimate_filter: payload
      })
    case RESET_ESTIMATE_FAILURE:
      return Object.assign({}, state, {
        resetEstimate: false,
        resettingEstimate: false,
        errors: errors
      })
    default:
      return state
  }
}

